import React from 'react';

export const CopyEditSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <g clipPath="url(#clip0_23668_15531)">
      <path
        d="M13.6427 7.99963C13.3271 7.99963 13.0712 8.25546 13.0712 8.57106V14.2853C13.0712 14.6009 12.8154 14.8567 12.4998 14.8567H2.21426C1.89866 14.8567 1.64283 14.6009 1.64283 14.2853V2.85684C1.64283 2.54124 1.89866 2.28541 2.21426 2.28541H9.07132C9.38691 2.28541 9.64275 2.02958 9.64275 1.71398C9.64275 1.39838 9.38691 1.14258 9.07132 1.14258H2.21426C1.2675 1.14258 0.5 1.91008 0.5 2.85684V14.2853C0.5 15.232 1.2675 15.9995 2.21426 15.9995H12.4998C13.4466 15.9995 14.2141 15.232 14.2141 14.2853V8.57103C14.2141 8.25546 13.9583 7.99963 13.6427 7.99963Z"
        fill="#282F33"
      />
      <path
        d="M15.8604 0.640782C15.4501 0.23043 14.8936 -5.7923e-05 14.3133 9.04044e-06C13.7327 -0.00166504 13.1756 0.229225 12.7665 0.64115L5.23967 8.1673C5.17723 8.23021 5.13012 8.30668 5.10196 8.39072L3.95913 11.8193C3.85939 12.1187 4.02127 12.4422 4.3207 12.542C4.37879 12.5613 4.43963 12.5712 4.50083 12.5712C4.56217 12.5711 4.62314 12.5613 4.6814 12.5421L8.10993 11.3993C8.19414 11.3712 8.27064 11.3238 8.33336 11.261L15.8601 3.73426C16.7144 2.88007 16.7145 1.49507 15.8604 0.640782ZM15.0521 2.92681L7.62364 10.3553L5.40424 11.0964L6.14308 8.87986L13.5744 1.45141C13.983 1.04367 14.6447 1.04434 15.0525 1.45288C15.2472 1.64805 15.357 1.91225 15.3578 2.18797C15.3585 2.46517 15.2485 2.73114 15.0521 2.92681Z"
        fill="#282F33"
      />
    </g>
    <defs>
      <clipPath id="clip0_23668_15531">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default CopyEditSvg;
